import { AxisType, ChartConfigMode, ChartSpecificColumnType, ColumnType, fetchQueryColumnsFromDimension, } from '@thoughtspot/ts-chart-sdk';
export function isMeasureNameColumn(col) {
    return col.chartSpecificColumnType === ChartSpecificColumnType.MEASURE_NAMES;
}
export function isMeasureValueColumn(col) {
    return col.chartSpecificColumnType === ChartSpecificColumnType.MEASURE_VALUES;
}
export function isMeasureCol(col) {
    return col.type === ColumnType.MEASURE;
}
export function getMeasureCols(cols) {
    return cols.filter(isMeasureCol);
}
export function getAllDimensionCols(cols) {
    return cols.filter((c) => c.type === ColumnType.ATTRIBUTE || isMeasureNameColumn(c));
}
export function getMNField(columns) {
    return columns.find(isMeasureNameColumn);
}
export function getMVField(columns) {
    return columns.find(isMeasureValueColumn);
}
export function getUniqueColumnsById(chartColumns) {
    const map = new Map();
    chartColumns.forEach((c) => map.set(c.id, c));
    return [...map.values()];
}
export function getUniqueColumnsFromConfigs(chartConfigs) {
    const map = new Map();
    chartConfigs.forEach((config) => {
        config.dimensions.forEach((dim) => {
            fetchQueryColumnsFromDimension(dim).forEach((col) => {
                map.set(col.id, col);
            });
        });
    });
    return [...map.values()];
}
function flattenAxisConfigColumns(config) {
    if (config.type === AxisType.FLAT) {
        return [config.column];
    }
    if (config.type === AxisType.MERGED) {
        return config.columns;
    }
    if (config.type === AxisType.DUAL) {
        return [
            ...flattenAxisConfigColumns(config.primary),
            ...flattenAxisConfigColumns(config.secondary),
        ];
    }
    return [];
}
export function getAxisDrivenSlotColumns(chartConfigs, slotKey) {
    if (!chartConfigs?.length) {
        return [];
    }
    const dimension = chartConfigs[0].dimensions.find((dim) => dim.key === slotKey);
    if (!dimension || dimension.mode !== ChartConfigMode.AXIS_DRIVEN) {
        return [];
    }
    const axes = dimension.axes;
    if (!Array.isArray(axes)) {
        return [];
    }
    return axes.flatMap(flattenAxisConfigColumns);
}
export function configReferencesMeasureNames(chartConfigs) {
    return chartConfigs.some((config) => config.dimensions.some((dim) => fetchQueryColumnsFromDimension(dim).some(isMeasureNameColumn)));
}
//# sourceMappingURL=helpers.js.map